import { CommonModule, NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CdkDrag, CdkDropList, CdkDropListGroup, CdkDragPlaceholder } from '@angular/cdk/drag-drop';
import { Question } from 'src/app/models/question.model';
import { EQuestionType, QuestionType } from 'src/app/models/questionType.model';
import { map } from 'rxjs';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DragStore } from 'src/app/store/drag-store';
import { GlobalStore } from 'src/app/store/global-store';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-question-type-menu',
    imports: [CommonModule, NgFor, MatIconModule, CdkDrag, CdkDropListGroup,
        CdkDrag, DragDropModule, CdkDragPlaceholder, TranslateDirective, TranslatePipe,
        CdkDropList],
    templateUrl: './question-type-menu.component.html',
    styleUrls: ['./question-type-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionTypeMenuComponent {
  @Input() isInFollowUpQuestionPopup = false;
  @Output() addTypeQuestionEmit = new EventEmitter<QuestionType>();
  #dragStore = inject(DragStore)

  WordsOpen: boolean = false;
  TypeOpen: boolean = false;
  ButtonOpen: boolean = false;

  #globalStore = inject(GlobalStore);

  types$ = this.#globalStore.questionTypes$;
  loading$ = toSignal(this.#globalStore.loadingTypes$);
  typeSpecial23$ = this.#globalStore.questionTypes$.pipe(map(x => x.questions.find(t => t.id == 23)));
  dragTypeId$ = this.#dragStore.dragTypeId$;

  openType() {
    this.TypeOpen = !this.TypeOpen;
  }
  openWords() {
    this.WordsOpen = !this.WordsOpen;
  }
  openButtons() {
    this.ButtonOpen = !this.ButtonOpen;
  }
  startDrag(type: QuestionType) {
    this.#dragStore.updatDragType(type);
    this.#dragStore.updatDragEvent(true);
  }

  openAutoFillSelect() {
    this.#dragStore.openAndCloseCollectionQuestions(true);
  }
  noReturnPredicate(item: CdkDrag<number>) {
    return false;
  }

  addItemToBoard(type: any) {
    this.addTypeQuestionEmit.emit(type);
  }
  getScaleImgClass(id: number) {
    var scaleImgTypeHe = [
      EQuestionType.Mark, EQuestionType.Autocomplete, EQuestionType.FreeText,
      EQuestionType.Text, EQuestionType.QuestionsGroup
    ];
    // var scaleImgTypeEn = [EQuestionType.Multi, EQuestionType.Autocomplete, EQuestionType.Mark, EQuestionType.FreeText,
    // EQuestionType.Number, EQuestionType.Table, EQuestionType.PhoneNumber, EQuestionType.Range, EQuestionType.Title,
    // EQuestionType.Text, EQuestionType.Link, EQuestionType.UploadFile,
    // EQuestionType.Fill, EQuestionType.Divider, EQuestionType.Date, EQuestionType.QuestionsGroup, EQuestionType.Signature
    //   , EQuestionType.Image,
    // EQuestionType.UploadFileAdmin
    // ];
    var classes = "";
    if (scaleImgTypeHe.includes(id as EQuestionType)) {
      classes += "scale-img-he ";
    }
    // if (scaleImgTypeEn.includes(id as EQuestionType)) {
    //   classes += " scale-imvg";
    // }
    return classes;
  }
}
